import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "text-white" }
const _hoisted_2 = { class: "max-w-5xl mx-auto px-6 py-10" }
const _hoisted_3 = { class: "bg-white/5 rounded-xl p-6 mb-10 backdrop-blur-sm" }
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-center p-4"
}
const _hoisted_7 = {
  key: 1,
  class: "text-sm p-4 flex justify-center items-center"
}
const _hoisted_8 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = { class: "mt-4 grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_12 = { class: "bg-white/5 rounded-lg p-3" }
const _hoisted_13 = { class: "flex justify-between items-center mb-1" }
const _hoisted_14 = { class: "text-xs text-[#9CA3AF]" }
const _hoisted_15 = { class: "w-full bg-white/10 rounded-full h-2" }
const _hoisted_16 = { class: "bg-white/5 rounded-lg p-3" }
const _hoisted_17 = { class: "flex justify-between items-center mb-1" }
const _hoisted_18 = { class: "text-xs text-[#9CA3AF]" }
const _hoisted_19 = { class: "w-full bg-white/10 rounded-full h-2" }
const _hoisted_20 = { class: "mt-4" }
const _hoisted_21 = {
  key: 0,
  class: "bg-amber-500/20 border border-amber-500/30 rounded-lg p-4 mb-4 animate-pulse"
}
const _hoisted_22 = { class: "flex items-start" }
const _hoisted_23 = { class: "text-[#9CA3AF] text-sm mt-1" }
const _hoisted_24 = {
  key: 0,
  class: "block"
}
const _hoisted_25 = {
  key: 1,
  class: "block"
}
const _hoisted_26 = { class: "flex justify-end mt-6" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "bg-white/5 rounded-xl overflow-hidden backdrop-blur-sm" }
const _hoisted_29 = { class: "flex items-center gap-2" }
const _hoisted_30 = { class: "flex items-center" }
const _hoisted_31 = { class: "h-8 w-8 rounded-full bg-emerald-500/20 flex items-center justify-center mr-3" }
const _hoisted_32 = { class: "text-sm font-medium text-white" }
const _hoisted_33 = { class: "bg-emerald-500/20 text-emerald-400 px-2 py-0.5 rounded-full text-sm" }
const _hoisted_34 = { class: "text-sm font-medium text-white" }
const _hoisted_35 = { class: "flex gap-2" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "mt-10 bg-white/5 rounded-xl p-6 backdrop-blur-sm" }
const _hoisted_38 = { class: "flex flex-col md:flex-row items-start gap-6" }
const _hoisted_39 = { class: "rounded-full bg-emerald-500/20 p-4 shrink-0" }
const _hoisted_40 = { class: "flex-1" }
const _hoisted_41 = { class: "mt-6 grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_42 = { class: "bg-white/5 p-5 rounded-lg" }
const _hoisted_43 = { class: "font-medium mb-3 flex items-center text-emerald-400" }
const _hoisted_44 = { class: "mt-3 space-y-2 text-sm text-[#9CA3AF]" }
const _hoisted_45 = { class: "flex justify-between items-center bg-white/5 p-2 rounded" }
const _hoisted_46 = { class: "flex items-center" }
const _hoisted_47 = { class: "h-6 w-6 rounded-full bg-emerald-500/20 flex items-center justify-center mr-2" }
const _hoisted_48 = { class: "flex justify-between items-center bg-white/5 p-2 rounded" }
const _hoisted_49 = { class: "flex items-center" }
const _hoisted_50 = { class: "h-6 w-6 rounded-full bg-emerald-500/20 flex items-center justify-center mr-2" }
const _hoisted_51 = { class: "bg-white/5 p-5 rounded-lg" }
const _hoisted_52 = { class: "font-medium mb-3 flex items-center text-amber-400" }
const _hoisted_53 = { class: "space-y-3 text-sm" }
const _hoisted_54 = { class: "flex items-start gap-3 bg-white/5 p-3 rounded" }
const _hoisted_55 = { class: "h-6 w-6 rounded-full bg-amber-500/20 flex items-center justify-center shrink-0 mt-0.5" }
const _hoisted_56 = { class: "flex items-start gap-3 bg-white/5 p-3 rounded" }
const _hoisted_57 = { class: "h-6 w-6 rounded-full bg-amber-500/20 flex items-center justify-center shrink-0 mt-0.5" }

import { ref, computed, onUnmounted, onMounted } from 'vue'
import { 
  Building2, 
  Percent, 
  DollarSign, 
  ChevronDown, 
  PlusCircle, 
  Search, 
  Edit2, 
  Trash2, 
  AlertCircle,
  Info as InfoIcon,
  Calculator,
  Check,
  AlertTriangle,
  Split,
  Loader2
} from 'lucide-vue-next'

// Importação dos componentes de tabela
import Table from '@/components/ui/table/Table.vue'
import TableHeader from '@/components/ui/table/TableHeader.vue'
import TableBody from '@/components/ui/table/TableBody.vue'
import TableRow from '@/components/ui/table/TableRow.vue'
import TableHead from '@/components/ui/table/TableHead.vue'
import TableFallback from '@/components/ui/table/TableFallback.vue'
import TableCell from '@/components/ui/table/TableCell.vue'
import { CreatePaymentSplitDTO, usePaymentSplit } from '@/composables/usePaymentSplit'
import { useOrganization } from '@/composables/useOrganization'
import { Organization } from '@/interfaces/organizations/Organization'
import { PaymentSplit } from '@/interfaces/payment-splits/PaymentSplit'
import { Pagination as IPagination } from '@/interfaces/Pagination'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import TableRowSkeleton from '@/components/ui/table/TableRowSkeleton.vue'
import { toast } from '@/components/ui/toast'
import DeleteConfirmationDialog from '@/components/ui/delete-dialog/DeleteConfirmationDialog.vue'

interface TableHeader {
  key: string
  label: string
  sortable?: boolean
  class?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MyAccountView',
  setup(__props) {

const organizations = ref<Organization[]>()
const paymentSplits = ref<IPagination<PaymentSplit>>()
  
const { getAll: getAllPaymentSplits, create: createPaymentSplit, destroy: destroyPaymentSplit } = usePaymentSplit()
const { getAll: getAllOrganizations, organization } = useOrganization()
const selectableOrganizations = computed(() => organizations.value?.filter(org => !paymentSplits.value?.data.some(split => split.commissionRecipientOrganizationId === org.id) && org.id != organization.id) || [])
const isCreatingPaymentSplit = ref(false)
const isDeletingPaymentSplit = ref(false)
const isDeletePaymentSplitDialogOpen = ref(false)
const deletingPaymentSplit = ref<PaymentSplit | null>(null)

const handlePaymentSplitCreate = async () => {
  isCreatingPaymentSplit.value = true
  await createPaymentSplit(paymentSplitForm.value as CreatePaymentSplitDTO)
  paymentSplitForm.value = {}
  isCreatingPaymentSplit.value = false
  paymentSplits.value = await getAllPaymentSplits()
}

// Configuração dos cabeçalhos da tabela
const tableHeaders = ref<TableHeader[]>([
  { key: 'organizacao', label: 'ORGANIZAÇÃO', sortable: true },
  { key: 'percentual', label: 'PERCENTUAL', sortable: true },
  { key: 'valorFixo', label: 'VALOR FIXO', sortable: true },
  // { key: 'descricao', label: 'DESCRIÇÃO' },
  { key: 'acoes', label: 'AÇÕES', class: 'text-right' }
])

// Estado para nova organização
const paymentSplitForm = ref<Partial<CreatePaymentSplitDTO>>({})

// Estado para ordenação
const sortConfig = ref({
  key: '',
  direction: 'asc'
})

// Validação da nova organização
const paymentSplitFormValida = computed(() => {
  return paymentSplitForm.value.commissionRecipientOrganizationId && 
         ((paymentSplitForm.value.percentage ?? 0) > 0 || (paymentSplitForm.value.amount ?? 0) > 0)
})

// Cálculo do total de percentual
const totalPercentual = computed(() => {
  return paymentSplits.value?.data.reduce((total, org) => total + org.percentage, 0)
})

// Cálculo do total de valor fixo
const totalValorFixo = computed(() => {
  return paymentSplits.value?.data.reduce((total, org) => total + org.amount, 0)
})

// Verificação se os limites foram excedidos
const limitsExceeded = computed(() => {
  const currentPercentTotal = totalPercentual.value || 0;
  const currentFixedTotal = totalValorFixo.value || 0;
  
  // Verifica se adicionando o novo percentual excederia 30%
  const newPercentTotal = currentPercentTotal + (paymentSplitForm.value.percentage || 0);
  
  // Verifica se adicionando o novo valor fixo excederia 1 BRL
  const newFixedTotal = currentFixedTotal + (paymentSplitForm.value.amount || 0);
  
  return {
    percent: newPercentTotal > 30,
    fixed: newFixedTotal > 1,
    any: newPercentTotal > 30 || newFixedTotal > 1
  };
});

function handleDeletePaymentSplit(paymentSplit: PaymentSplit) {
  deletingPaymentSplit.value = paymentSplit
  isDeletePaymentSplitDialogOpen.value = true
}

function sortBy(key: string) {
  if (sortConfig.value.key === key) {
    // Inverter direção se já estiver ordenando por esta coluna
    sortConfig.value.direction = sortConfig.value.direction === 'asc' ? 'desc' : 'asc'
  } else {
    // Nova coluna para ordenação
    sortConfig.value.key = key
    sortConfig.value.direction = 'asc'
  }
}

const getOrganizationName = (id: number) => {
  const org = organizations.value?.find(o => o.id === id)
  return org ? org.name : 'Organização Desconhecida'
}

onMounted(async () => {
  getAllOrganizations()
    .then((data) => {
      organizations.value = data
    })
  getAllPaymentSplits()
    .then((data) => {
      paymentSplits.value = data
    })
})

return (_ctx: any,_cache: any) => {
  const _component_ArrowsUpDown = _resolveComponent("ArrowsUpDown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "mb-8" }, [
        _createElementVNode("h1", { class: "text-3xl font-bold mb-3" }, "Configure o Split de Comissões"),
        _createElementVNode("p", { class: "text-[#9CA3AF] leading-relaxed text-sm" }, " Defina como as comissões serão distribuídas entre organizações parceiras. Para cada venda realizada, você pode configurar valores fixos e/ou percentuais que serão automaticamente repassados. Configure múltiplos splits para diferentes organizações e acompanhe tudo em tempo real. ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "text-xl font-bold mb-4" }, "Adicionar Nova Organização", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { class: "block text-sm font-medium text-[#9CA3AF] mb-2" }, "Organização Receptora", -1)),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(Select), {
                modelValue: paymentSplitForm.value.commissionRecipientOrganizationId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((paymentSplitForm.value.commissionRecipientOrganizationId) = $event)),
                multiple: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(SelectTrigger), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(SelectValue), { placeholder: "Selecione a categoria" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(SelectContent), null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectableOrganizations.value, (org) => {
                        return (_openBlock(), _createBlock(_unref(SelectItem), {
                          key: org.id,
                          value: String(org.id)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(org.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128)),
                      (!organizations.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_unref(Loader2), { class: "w-5 h-5 animate-spin" })
                          ]))
                        : _createCommentVNode("", true),
                      (organizations.value && !selectableOrganizations.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_unref(Search), { class: "w-5 h-5 text-[#9CA3AF] mr-2" }),
                            _cache[5] || (_cache[5] = _createTextVNode(" Nenhuma organização encontrada "))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { class: "block text-sm font-medium text-[#9CA3AF] mb-2" }, "Percentual (%)", -1)),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(Input), {
                  modelValue: paymentSplitForm.value.percentage,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((paymentSplitForm.value.percentage) = $event)),
                  type: "number",
                  min: "0",
                  max: "100",
                  class: "w-full border-0 text-white rounded-lg p-3 focus:ring-1 focus:ring-emerald-500",
                  placeholder: "0.00"
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(Percent), { class: "absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-[#9CA3AF]" })
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "block text-sm font-medium text-[#9CA3AF] mb-2" }, "Valor Fixo (R$)", -1)),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_unref(Input), {
                  modelValue: paymentSplitForm.value.amount,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((paymentSplitForm.value.amount) = $event)),
                  type: "number",
                  min: "0",
                  step: "0.01",
                  class: "w-full border-0 text-white rounded-lg p-3 focus:ring-1 focus:ring-emerald-500",
                  placeholder: "0.00"
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(DollarSign), { class: "absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-[#9CA3AF]" })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, "Percentual Total: " + _toDisplayString(totalPercentual.value || 0) + "% / 30%", 1),
              _createElementVNode("span", {
                class: _normalizeClass(["text-xs", (totalPercentual.value || 0) > 30 ? 'text-red-400' : 'text-emerald-400'])
              }, _toDisplayString(Math.min(Math.round(((totalPercentual.value || 0) / 30) * 100), 100)) + "% ", 3)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", {
                class: _normalizeClass(["h-2 rounded-full transition-all duration-300", (totalPercentual.value || 0) > 30 ? 'bg-red-400' : 'bg-emerald-400']),
                style: _normalizeStyle(`width: ${Math.min(((totalPercentual.value || 0) / 30) * 100, 100)}%`)
              }, null, 6)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, "Valor Fixo Total: " + _toDisplayString((totalValorFixo.value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })) + " / R$ 1,00", 1),
              _createElementVNode("span", {
                class: _normalizeClass(["text-xs", (totalValorFixo.value || 0) > 1 ? 'text-red-400' : 'text-emerald-400'])
              }, _toDisplayString(Math.min(Math.round(((totalValorFixo.value || 0) / 1) * 100), 100)) + "% ", 3)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", {
                class: _normalizeClass(["h-2 rounded-full transition-all duration-300", (totalValorFixo.value || 0) > 1 ? 'bg-red-400' : 'bg-emerald-400']),
                style: _normalizeStyle(`width: ${Math.min(((totalValorFixo.value || 0) / 1) * 100, 100)}%`)
              }, null, 6)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          (limitsExceeded.value.any)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_unref(AlertTriangle), { class: "h-5 w-5 text-amber-400 mr-3 mt-0.5 flex-shrink-0" }),
                  _createElementVNode("div", null, [
                    _cache[10] || (_cache[10] = _createElementVNode("h4", { class: "font-medium text-amber-400" }, "Limite de Split Excedido", -1)),
                    _createElementVNode("p", _hoisted_23, [
                      (limitsExceeded.value.percent)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, "• O total de percentual não pode exceder 30% (atual: " + _toDisplayString(totalPercentual.value) + "% + novo: " + _toDisplayString(paymentSplitForm.value.percentage || 0) + "%)", 1))
                        : _createCommentVNode("", true),
                      (limitsExceeded.value.fixed)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, "• O valor fixo total não pode exceder R$ 1,00 (atual: " + _toDisplayString((totalValorFixo.value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })) + " + novo: " + _toDisplayString((paymentSplitForm.value.amount ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })) + ")", 1))
                        : _createCommentVNode("", true),
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "block mt-1 text-amber-400" }, "Ajuste os valores para continuar.", -1))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("button", {
            onClick: handlePaymentSplitCreate,
            class: _normalizeClass(["bg-emerald-500 hover:bg-emerald-600 text-white px-6 py-2.5 rounded-lg font-medium transition-colors flex items-center", {'opacity-50 cursor-not-allowed': !paymentSplitFormValida.value || isCreatingPaymentSplit.value || limitsExceeded.value.any}]),
            disabled: !paymentSplitFormValida.value || isCreatingPaymentSplit.value || limitsExceeded.value.any
          }, [
            (isCreatingPaymentSplit.value)
              ? (_openBlock(), _createBlock(_unref(Loader2), {
                  key: 0,
                  class: "w-5 h-5 mr-2 animate-spin"
                }))
              : (_openBlock(), _createBlock(_unref(PlusCircle), {
                  key: 1,
                  class: "h-5 w-5 mr-2"
                })),
            _cache[11] || (_cache[11] = _createTextVNode(" Adicionar Organização "))
          ], 10, _hoisted_27)
        ])
      ]),
      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" }, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", { class: "text-xl font-bold" }, "Splits Configurados"),
          _createElementVNode("p", { class: "text-[#9CA3AF] text-sm mt-1" }, "Gerencie as organizações que receberão comissões")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_28, [
        _createVNode(Table, null, {
          default: _withCtx(() => [
            _createVNode(TableHeader, null, {
              default: _withCtx(() => [
                _createVNode(TableRow, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableHeaders.value, (header) => {
                      return (_openBlock(), _createBlock(TableHead, {
                        key: header.key,
                        class: _normalizeClass(header.class)
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_29, [
                            _createTextVNode(_toDisplayString(header.label) + " ", 1),
                            (header.sortable)
                              ? (_openBlock(), _createBlock(_component_ArrowsUpDown, {
                                  key: 0,
                                  class: "h-4 w-4 cursor-pointer text-gray-500 hover:text-white",
                                  onClick: ($event: any) => (sortBy(header.key))
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["class"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(TableBody, null, {
              default: _withCtx(() => [
                (paymentSplits.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (paymentSplits.value?.data.length === 0)
                        ? (_openBlock(), _createBlock(TableFallback, {
                            key: 0,
                            colspan: tableHeaders.value.length,
                            icon: _unref(Split),
                            title: "Nenhuma organização configurada",
                            description: "Adicione uma organização para começar a configurar os splits"
                          }, null, 8, ["colspan", "icon"]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentSplits.value?.data, (split, index) => {
                        return (_openBlock(), _createBlock(TableRow, { key: index }, {
                          default: _withCtx(() => [
                            _createVNode(TableCell, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("div", _hoisted_31, [
                                    _createVNode(_unref(Building2), { class: "h-4 w-4 text-emerald-400" })
                                  ]),
                                  _createElementVNode("div", _hoisted_32, _toDisplayString(getOrganizationName(split.organizationId)), 1)
                                ])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, null, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_33, _toDisplayString(split.percentage) + "% ", 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_34, _toDisplayString(split.amount?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_35, [
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (handleDeletePaymentSplit(split)),
                                    class: "p-2 rounded-md hover:bg-white/10 text-[#9CA3AF] hover:text-white transition-colors"
                                  }, [
                                    _createVNode(_unref(Trash2), { class: "h-4 w-4" })
                                  ], 8, _hoisted_36)
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ], 64))
                  : (_openBlock(), _createBlock(TableRowSkeleton, {
                      key: 1,
                      columns: tableHeaders.value.length
                    }, null, 8, ["columns"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_unref(InfoIcon), { class: "h-6 w-6 text-emerald-400" })
          ]),
          _createElementVNode("div", _hoisted_40, [
            _cache[23] || (_cache[23] = _createElementVNode("h3", { class: "text-lg font-bold mb-1" }, "Como funcionam as comissões", -1)),
            _cache[24] || (_cache[24] = _createElementVNode("p", { class: "text-[#9CA3AF] text-sm leading-relaxed" }, [
              _createTextVNode(" Para cada venda realizada, o sistema irá automaticamente distribuir as comissões conforme configurado acima. Você pode definir um percentual sobre o valor da venda e/ou um valor fixo para cada organização parceira. "),
              _createElementVNode("span", { class: "text-emerald-400" }, "O split é processado em tempo real"),
              _createTextVNode(" e os valores são depositados diretamente nas contas das organizações receptoras. ")
            ], -1)),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("h4", _hoisted_43, [
                  _createVNode(_unref(Calculator), { class: "h-5 w-5 mr-2" }),
                  _cache[13] || (_cache[13] = _createTextVNode(" Exemplo de cálculo "))
                ]),
                _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-[#9CA3AF] text-sm" }, [
                  _createTextVNode(" Para uma venda de "),
                  _createElementVNode("span", { class: "text-white font-medium" }, "R$ 100,00"),
                  _createTextVNode(": ")
                ], -1)),
                _createElementVNode("ul", _hoisted_44, [
                  _createElementVNode("li", _hoisted_45, [
                    _createElementVNode("span", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_unref(Building2), { class: "h-3 w-3 text-emerald-400" })
                      ]),
                      _cache[14] || (_cache[14] = _createTextVNode(" Organização A (10% + R$ 5,00 fixo): "))
                    ]),
                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-white font-medium" }, "R$ 15,00", -1))
                  ]),
                  _createElementVNode("li", _hoisted_48, [
                    _createElementVNode("span", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createVNode(_unref(Building2), { class: "h-3 w-3 text-emerald-400" })
                      ]),
                      _cache[16] || (_cache[16] = _createTextVNode(" Organização B (5% + R$ 0,00 fixo): "))
                    ]),
                    _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-white font-medium" }, "R$ 5,00", -1))
                  ]),
                  _cache[18] || (_cache[18] = _createElementVNode("li", { class: "flex justify-between mt-3 pt-3 border-t border-white/10 font-medium" }, [
                    _createElementVNode("span", null, "Total repassado:"),
                    _createElementVNode("span", { class: "text-emerald-400" }, "R$ 20,00")
                  ], -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("h4", _hoisted_52, [
                  _createVNode(_unref(AlertTriangle), { class: "h-5 w-5 mr-2" }),
                  _cache[20] || (_cache[20] = _createTextVNode(" Limites e Recomendações "))
                ]),
                _createElementVNode("ul", _hoisted_53, [
                  _createElementVNode("li", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(_unref(Percent), { class: "h-3 w-3 text-amber-400" })
                    ]),
                    _cache[21] || (_cache[21] = _createElementVNode("div", null, [
                      _createElementVNode("span", { class: "text-white font-medium" }, "Limite de Percentual: 30%"),
                      _createElementVNode("p", { class: "text-[#9CA3AF] mt-1" }, "Mantenha o percentual total abaixo de 30% para garantir margem de lucro adequada.")
                    ], -1))
                  ]),
                  _createElementVNode("li", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _createVNode(_unref(DollarSign), { class: "h-3 w-3 text-amber-400" })
                    ]),
                    _cache[22] || (_cache[22] = _createElementVNode("div", null, [
                      _createElementVNode("span", { class: "text-white font-medium" }, "Limite de Valor Fixo: R$ 1,00"),
                      _createElementVNode("p", { class: "text-[#9CA3AF] mt-1" }, "Configure valores fixos com cautela para evitar prejuízos em vendas de baixo valor.")
                    ], -1))
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(DeleteConfirmationDialog, {
        open: isDeletePaymentSplitDialogOpen.value,
        "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((isDeletePaymentSplitDialogOpen).value = $event)),
        loading: isDeletingPaymentSplit.value,
        onConfirm: _cache[4] || (_cache[4] = ($event: any) => {isDeletingPaymentSplit.value = true; _unref(destroyPaymentSplit)(deletingPaymentSplit.value!.id).then(() => {
        _unref(toast)({
          title: 'Split excluído com sucesso',
          class: 'bg-green-500 text-white',
          duration: 1500
        })
        isDeletingPaymentSplit.value = false
        isDeletePaymentSplitDialogOpen.value = false
        const index = paymentSplits.value?.data.findIndex(split => split.id == deletingPaymentSplit.value?.id)
        if (index !== -1) paymentSplits.value?.data.splice(index!, 1)
      })})
      }, null, 8, ["open", "loading"])
    ])
  ]))
}
}

})